export const M_Modal_OptionsDefaults = {
	accent: "primary",
	replaceCurrent: false,
	namespace: null,
};
